module.exports = __webpack_public_path__ + "static/comments-b832f9fbfd9df0ad02a44e4531ff0ec1.png";